import AlternativeItineraryDoubleCardLayerSectionTitle from './AlternativeItineraryDoubleCardLayerSectionTitle';

export default AlternativeItineraryDoubleCardLayerSectionTitle;
